import request from '@/utils/shortRequest'

export default {
  inviteConfig (params, config = {}) {
    return request({
      url: '/invitation/invite_config',
      method: 'get',
      params,
      ...config
    })
  },
  inviteData (params, config = {}) {
    return request({
      url: '/invitation/invite_data',
      method: 'get',
      params,
      ...config
    })
  },
  inviteRecord (params, config = {}) {
    return request({
      url: '/invitation/records',
      method: 'get',
      params,
      ...config
    })
  },
  inviteShare (params, config = {}) {
    return request({
      url: '/invitation/share_info',
      method: 'get',
      params,
      ...config
    })
  }
}
